// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2802":"bbcb458c","9572":"11d6bea4"}[chunkId] + ".chunk.css";
};